import { Redirect } from "@/crossPlatform/expo-router";

const LoginAlias = () => {
  return <Redirect href="/" />;
};

// eslint-disable-next-line import-x/no-unused-modules
export default LoginAlias;
